import React, { SyntheticEvent, useEffect, useRef, useState } from "react";
import { BarChart } from "@mui/x-charts";
import {
  Table,
  TableBody,
  TableCell,
  Button,
  Grid,
  TableContainer,
  Typography,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  Autocomplete,
  TextField,
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../../hooks/hooks";
import { getLastPurchaseDetail } from "../../../../store/thunks/portalManagementThunk";
import {
  isSaleLeadRequested,
  markSaleLeadRequested,
} from "../analyticsAggregateFetch";
import {
  GetArray,
  GetObject,
  WithCommas,
  exportToExcelOther,
} from "../../../../utils/utils";
import MiniSpinner from "../../../reusableComponents/miniSpinner/miniSpinner";
import { QueryClient, QueryClientProvider } from "react-query";
import FrequentlyPurchased from "./frequentlyPurchased/frequentlyPurchased";
import SectionCard from "../../../reusableComponents/sectionCard/sectionCard";
import SegmentedControl from "../../../reusableComponents/segmentedControl/segmentedControl";
import { tokens } from "../../../../theme";

const frequentlyPurchasedClient = new QueryClient();

const SalesMarketing = () => {
  const {
    selectedBranch,
    selectedDepartment,
    verifiedSunRawData,
    formFillSumRawData,
    gainLost6RawData,
    gainLost12RawData,
    gainLost36RawData,
    revinvData,
    marketCustRawData,
    marketCustAllRawData,
    prcustRawData,
    prrevRawData,
    salstbRawData,
    salemRawData,
    prospectLeadsReportsLoading,
    lastPurchaseCustomerLeadsLoading,
    marketByCustomerLoading,
    productByCustomerCountLoading,
    rankByStableAccountLoading,
    getAssociatedProductLoading,
    leadRawData,
    lostRawData,
    gainRawData,
    // saleLeadRawData,
    prospectleadDetailRawData,
    rankByRetentionData,

    prRawData,
    ruleRawData,
    cassRawData,
    branchRankByStableData,
    branchRankByEmailData,
    branchRankByRetentionData,
    associatedProductData,
  } = useAppSelector((state: any) => state.portalManagement);

  const {
    saleLeadRawData
  } = useAppSelector((state: any) => state.portalManagementX);
  const { selectedClient } = useAppSelector(
    (state: any) => state.portalManagement
  );
  const dispatch = useAppDispatch();

  // last_purchase_detail (~6.6 MB) feeds only the lead-list download. Landing
  // idle-prefetches it; this is the fallback if the user opens download first.
  const saleLeadRequestedRef = useRef(false);
  const requestSaleLeadIfNeeded = () => {
    if (saleLeadRawData || saleLeadRequestedRef.current) return;
    if (!selectedClient?.customer_id) return;
    if (isSaleLeadRequested(selectedClient.customer_id)) {
      saleLeadRequestedRef.current = true;
      return;
    }
    saleLeadRequestedRef.current = true;
    markSaleLeadRequested(selectedClient.customer_id);
    dispatch(
      getLastPurchaseDetail({ customer_id: selectedClient.customer_id })
    );
  };

  useEffect(() => {
    saleLeadRequestedRef.current = false;
  }, [selectedClient?.customer_id]);

  const [
    salesMarketingProsperLeadVerifiedInfo,
    setSalesMarketingProsperLeadVerifiedInfo,
  ] = useState({
    monthYear: "",
    accountM: "",
    account6M: "",
    account12M: "",
    constactM: "",
    constact6M: "",
    constact12M: "",
    emailM: "",
    email6M: "",
    email12M: "",
    accountTotal: "",
    emailTotal: "",
    countactTotal: "",
  });

  const [
    salesMarketingProsperLeadFormFillInfo,
    setSalesMarketingProsperLeadFormFillInfo,
  ] = useState({
    monthYear: "",
    formFillM: "",
    formFill6M: "",
    formFill12M: "",
  });

  const [
    salesMarketingProsperLeadEmailFormFillInfo,
    setSalesMarketingProsperLeadEmailFormFillInfo,
  ] = useState({
    visitor: "",
    monthYear: "",
    activeRecipient: "",
    activeOpenRate: "",
    activeClickRate: "",
    inactiveRecipient: "",
    inactiveOpenRate: "",
    inactiveClickRate: "",
  });

  const [salesMarketingMarketCustTable, setSalesMarketingMarketCustTable] =
    useState<any[]>([]);

  const [
    salesMarketingProductCustomerChartdata,
    setsalesMarketingProductCustomerChartdata,
  ] = useState([]);

  const [
    salesMarketingProductCustomerChartLabel,
    setsalesMarketingProductCustomerChartLabel,
  ] = useState([]);

  const [
    salesMarketingProductRevenueChartLabel,
    setsalesMarketingProductRevenueChartLabel,
  ] = useState([]);

  const [
    salesMarketingProductRevenueChartData,
    setsalesMarketingProductRevenueChartData,
  ] = useState([]);

  const [
    salesMarketingStableAccountChartData,
    setsalesMarketingStableAccountChartData,
  ] = useState([]);

  const [
    salesMarketingStableAccountChartLabel,
    setsalesMarketingStableAccountChartLabel,
  ] = useState([]);

  const [salesMarketingEmailChartData, setsalesMarketingEmailChartData] =
    useState([]);

  const [salesMarketingEmailChartLabel, setsalesMarketingEmailChartLabel] =
    useState([]);

  const [
    salesMarketingRetentionChartData,
    setsalesMarketingRetentionChartData,
  ] = useState([]);

  const [
    salesMarketingRetentionChartLabel,
    setsalesMarketingRetentionChartLabel,
  ] = useState([]);

  const [
    salesMarketingBranchRankByStableData,
    setsalesMarketingBranchRankByStableData,
  ] = useState([]);
  const [
    salesMarketingBranchRankByStableLabel,
    setsalesMarketingBranchRankByStableLabel,
  ] = useState([]);

  const [
    salesMarketingBranchRankByEmailData,
    setsalesMarketingBranchRankByEmailData,
  ] = useState([]);
  const [
    salesMarketingBranchRankByEmailLabel,
    setsalesMarketingBranchRankByEmailLabel,
  ] = useState([]);

  const [
    salesMarketingBranchRankByRetentionData,
    setsalesMarketingBranchRankByRetentionData,
  ] = useState([]);
  const [
    salesMarketingBranchRankByRetentionLabel,
    setsalesMarketingBranchRankByRetentionLabel,
  ] = useState([]);

  const [activeCustomerCount, setActiveCustomerCount] =
    useState("CUSTOMER_COUNT");

  const handleCustomerCountNav = (value: string) => {
    setActiveCustomerCount(value);
  };
  const [activeSMRevenueMonth, setActiveSMRevenueMonth] =
    useState("STABLE_ACCOUNT");

  const [saleleadDownloadData, setSaleleadDownloadData] = useState<any[]>([]);

  const handleSMRevenueMonthNav = (value: string) => {
    setActiveSMRevenueMonth(value);
  };

  const [salesMarketingLeadsCustomers, setsalesMarketingLeadsCustomers] =
    useState({
      cust_lead: "",
      lead_purchase: "",
      lead_rev: "",
    });

  const [salesMarketingLostCustomers, setsalesMarketingLostCustomers] =
    useState({ cust_lost: "", lost_purchase: "", lost_rev: "" });

  const [salesMarketingGainedCustomers, setsalesMarketingGainedCustomers] =
    useState({ cust_gain: "", gain_purchase: "", gain_rev: "" });

  const [
    salesMarketingCrossSellProductdata,
    setSalesMarketingCrossSellProductdata,
  ] = useState([]);

  const [
    salesMarketingTransactionsCountChartData,
    setsalesMarketingTransactionsCountChartData,
  ] = useState([]);

  const [
    salesMarketingTransactionsCountChartLabel,
    setsalesMarketingTransactionsCountChartLabel,
  ] = useState([]);

  const periodOption = [
    { label: "6 months", value: "6 months" },
    { label: "12 months", value: "12 months" },
    { label: "24 months", value: "24 months" },
    { label: "36 months", value: "36 months" },
  ];

  const programOption = [
    { label: "Verification Calling Program", value: "calling" },
    { label: "Email Program", value: "email" },
  ];

  const [selectedPeriod, setSelectedPeriod] = useState<any>({
    label: "12 months",
    value: "12 months",
  });

  const [selectedProgram, setSelectedProgram] = useState<any>({
    label: "Verification Calling Program",
    value: "calling",
  });

  const leadDownloadOption = [
    { label: "9 to 12 Weeks", value: "weeks" },
    { label: "Lost Customers", value: "lost" },
    { label: "Gained Customers", value: "new" },
    { label: "Active Customers", value: "active" },
  ];

  const [selectedLeadDownload, setSelectedLeadDownload] = useState<any>({
    label: "9 to 12 Weeks",
    value: "weeks",
  });

  const handlePeriodChange = (selection: any) => {
    if (selection) {
      setSelectedPeriod(selection);
    } else
      setSelectedPeriod({
        label: "12 months",
        value: "12 months",
      });
  };

  const handleProgramChange = (selection: any) => {
    if (selection) {
      setSelectedProgram(selection);
    } else
      setSelectedProgram({
        label: "Verification Calling Program",
        value: "calling",
      });
  };

  const handleLeadDownloadChange = (selection: any) => {
    requestSaleLeadIfNeeded();
    if (selection) {
      setSelectedLeadDownload(selection);
    } else setSelectedLeadDownload({ label: "9 to 12 Weeks", value: "weeks" });
  };

  const [salesmarketingActiveAccount, setSalesmarketingActiveAccount] =
    useState("");
  const [
    salesmarketingTransactionInvoiceActive,
    setSalesmarketingTransactionInvoiceActive,
  ] = useState("");
  const [
    salesmarketingRevenueActiveAccount,
    setSalesmarketingRevenueActiveAccount,
  ] = useState("");

  const [activeRank, setActiveRank] = useState("SALES_REP");

  const handleRankChange = (value: string) => {
    setActiveRank(value);
  };

  const [activeProductAnalysis, setActiveProductAnalysis] =
    useState("TOP_20_PRODUCT");

  const handleProductAnalysisChange = (value: string) => {
    setActiveProductAnalysis(value);
  };

  const salesMarketingFilterData = () => {
    if (verifiedSunRawData) {
      setSalesMarketingProsperLeadVerifiedInfo({
        monthYear: verifiedSunRawData.month_year
          ? verifiedSunRawData.month_year
          : "",
        accountM: verifiedSunRawData.account_m
          ? verifiedSunRawData.account_m
          : "",
        account6M: verifiedSunRawData.account_6m
          ? verifiedSunRawData.account_6m
          : "",
        account12M: verifiedSunRawData.account_12m
          ? verifiedSunRawData.account_12m
          : "",
        constactM: verifiedSunRawData.contact_m
          ? verifiedSunRawData.contact_m
          : "",
        constact6M: verifiedSunRawData.contact_6m
          ? verifiedSunRawData.contact_6m
          : "",
        constact12M: verifiedSunRawData.contact_12m
          ? verifiedSunRawData.contact_12m
          : "",
        emailM: verifiedSunRawData.email_m ? verifiedSunRawData.email_m : "",
        email6M: verifiedSunRawData.email_6m ? verifiedSunRawData.email_6m : "",
        email12M: verifiedSunRawData.email_12m
          ? verifiedSunRawData.email_12m
          : "",
        accountTotal: verifiedSunRawData.account_total
          ? verifiedSunRawData.account_total
          : "",
        countactTotal: verifiedSunRawData.contact_total
          ? verifiedSunRawData.contact_total
          : "",
        emailTotal: verifiedSunRawData.email_total
          ? verifiedSunRawData.email_total
          : "",
      });
    } else {
      setSalesMarketingProsperLeadVerifiedInfo({
        monthYear: "",
        accountM: "",
        account6M: "",
        account12M: "",
        constactM: "",
        constact6M: "",
        constact12M: "",
        emailM: "",
        email6M: "",
        email12M: "",
        accountTotal: "",
        emailTotal: "",
        countactTotal: "",
      });
    }

    if (formFillSumRawData) {
      setSalesMarketingProsperLeadFormFillInfo({
        monthYear: formFillSumRawData.month_year
          ? formFillSumRawData.month_year
          : "",
        formFillM: formFillSumRawData.ff_m ? formFillSumRawData.ff_m : "",
        formFill6M: formFillSumRawData.ff_6m ? formFillSumRawData.ff_6m : "",
        formFill12M: formFillSumRawData.ff_12m ? formFillSumRawData.ff_12m : "",
      });
    } else {
      setSalesMarketingProsperLeadFormFillInfo({
        monthYear: "",
        formFillM: "",
        formFill6M: "",
        formFill12M: "",
      });
    }

    if (marketCustRawData && marketCustAllRawData) {
      if (Object.keys(marketCustRawData).length !== 0) {
        let tempSalesMarketingMarketCustTable: any[] = [];

        const tempDataOne =
          marketCustRawData[selectedBranch.value][selectedDepartment.value][
            selectedPeriod.value
          ];
        const tempDatatwo =
          marketCustAllRawData[selectedBranch.value][selectedDepartment.value][
            selectedPeriod.value
          ];

        if (tempDataOne?.length === tempDatatwo?.length) {
          tempDataOne.forEach((element: any, index: any) => {
            let tempOther = tempDatatwo[index];

            tempSalesMarketingMarketCustTable.push({
              ...element,
              ...tempOther,
            });
          });
        }

        setSalesMarketingMarketCustTable(tempSalesMarketingMarketCustTable);
      } else {
        setSalesMarketingMarketCustTable([]);
      }
    }

    if (prcustRawData) {
      const prcustFilter = GetObject(
        GetArray(prcustRawData).filter(
          (item: any) =>
            item.BRANCH === selectedBranch.value &&
            item.DEPARTMENT === selectedDepartment.value
        )
      );

      if (Object.keys(prcustFilter).length !== 0) {
        setsalesMarketingProductCustomerChartdata(prcustFilter.customer_count);
        setsalesMarketingProductCustomerChartLabel(prcustFilter.product_cons);
      } else {
        setsalesMarketingProductCustomerChartdata([]);
        setsalesMarketingProductCustomerChartLabel([]);
      }
    }

    if (prrevRawData) {
      const prrevFilter = GetObject(
        GetArray(prrevRawData).filter(
          (item: any) =>
            item.BRANCH === selectedBranch.value &&
            item.DEPARTMENT === selectedDepartment.value
        )
      );

      if (Object.keys(prrevFilter).length !== 0) {
        setsalesMarketingProductRevenueChartData(prrevFilter.revenue);
        setsalesMarketingProductRevenueChartLabel(prrevFilter.product_cons);
      } else {
        setsalesMarketingProductRevenueChartData([]);
        setsalesMarketingProductRevenueChartLabel([]);
      }
    }

    if (salstbRawData) {
      const salstbFilter = GetObject(
        GetArray(salstbRawData).filter(
          (item: any) => item.BRANCH === selectedBranch.value
        )
      );

      if (Object.keys(salstbFilter).length !== 0) {
        setsalesMarketingStableAccountChartData(salstbFilter.STABLE_PERCENT);
        setsalesMarketingStableAccountChartLabel(salstbFilter.SALESMAN);
        // setsalesMarketingStableAccountChartLabel(salstbFilter.LABEL);
      } else {
        setsalesMarketingStableAccountChartData([]);
        setsalesMarketingStableAccountChartLabel([]);
      }
    }

    if (salemRawData) {
      const salemFilter = GetObject(
        GetArray(salemRawData).filter(
          (item: any) => item.BRANCH === selectedBranch.value
        )
      );

      if (Object.keys(salemFilter).length !== 0) {
        setsalesMarketingEmailChartData(salemFilter.EMAIL_PERCENT);
        setsalesMarketingEmailChartLabel(salemFilter.SALESMAN);
        // setsalesMarketingEmailChartLabel(salemFilter.LABEL);
      } else {
        setsalesMarketingEmailChartData([]);
        setsalesMarketingEmailChartLabel([]);
      }
    }

    if (leadRawData) {
      const lprCustLeadsFilter = GetObject(
        GetArray(leadRawData).filter(
          (item: any) =>
            item.BRANCH === selectedBranch.value &&
            item.PRODUCT_TYPE_ALL === selectedDepartment.value
        )
      );

      if (Object.keys(lprCustLeadsFilter).length !== 0) {
        setsalesMarketingLeadsCustomers({
          cust_lead: WithCommas(
            lprCustLeadsFilter.cust_lead &&
              lprCustLeadsFilter.cust_lead.length >= 1
              ? lprCustLeadsFilter.cust_lead[0]
              : "-"
          ),
          lead_purchase: WithCommas(
            lprCustLeadsFilter.lead_purchase &&
              lprCustLeadsFilter.lead_purchase.length >= 1
              ? lprCustLeadsFilter.lead_purchase[0]
              : "-"
          ),
          lead_rev: WithCommas(
            lprCustLeadsFilter.lead_rev &&
              lprCustLeadsFilter.lead_rev.length >= 1
              ? lprCustLeadsFilter.lead_rev[0]
              : "-"
          ),
        });
      } else {
        setsalesMarketingLeadsCustomers({
          cust_lead: "-",
          lead_purchase: "-",
          lead_rev: "-",
        });
      }
    }

    if (lostRawData) {
      const lprCustLostFilter = GetObject(
        GetArray(lostRawData).filter(
          (item: any) =>
            item.BRANCH === selectedBranch.value &&
            item.PRODUCT_TYPE_ALL === selectedDepartment.value
        )
      );

      if (Object.keys(lprCustLostFilter).length !== 0) {
        setsalesMarketingLostCustomers({
          cust_lost: WithCommas(
            lprCustLostFilter.cust_lead &&
              lprCustLostFilter.cust_lead.length >= 1
              ? lprCustLostFilter.cust_lead[0]
              : "-"
          ),
          lost_purchase: WithCommas(
            lprCustLostFilter.lead_purchase &&
              lprCustLostFilter.lead_purchase.length >= 1
              ? lprCustLostFilter.lead_purchase[0]
              : "-"
          ),
          lost_rev: WithCommas(
            lprCustLostFilter.lead_rev && lprCustLostFilter.lead_rev.length >= 1
              ? lprCustLostFilter.lead_rev[0]
              : "-"
          ),
        });
      } else {
        setsalesMarketingLostCustomers({
          cust_lost: "-",
          lost_purchase: "-",
          lost_rev: "-",
        });
      }
    }

    if (gainRawData) {
      const lprCustGainFilter = GetObject(
        GetArray(gainRawData).filter(
          (item: any) =>
            item.BRANCH === selectedBranch.value &&
            item.PRODUCT_TYPE_ALL === selectedDepartment.value
        )
      );

      if (Object.keys(lprCustGainFilter).length !== 0) {
        setsalesMarketingGainedCustomers({
          cust_gain: WithCommas(
            lprCustGainFilter.cust_lead &&
              lprCustGainFilter.cust_lead.length >= 1
              ? lprCustGainFilter.cust_lead[0]
              : "-"
          ),
          gain_purchase: WithCommas(
            lprCustGainFilter.lead_purchase &&
              lprCustGainFilter.lead_purchase.length >= 1
              ? lprCustGainFilter.lead_purchase[0]
              : "-"
          ),
          gain_rev: WithCommas(
            lprCustGainFilter.lead_rev && lprCustGainFilter.lead_rev.length >= 1
              ? lprCustGainFilter.lead_rev[0]
              : "-"
          ),
        });
      } else {
        setsalesMarketingGainedCustomers({
          cust_gain: "-",
          gain_purchase: "-",
          gain_rev: "-",
        });
      }
    }

    if (saleLeadRawData) {
      if (selectedLeadDownload.value === "weeks") {
        setSaleleadDownloadData(
          saleLeadRawData?.lead_lead?.[selectedBranch.value]?.[
            selectedDepartment.value
          ]
        );
      } else if (selectedLeadDownload.value === "lost") {
        setSaleleadDownloadData(
          saleLeadRawData?.lost_lead?.[selectedBranch.value]?.[
            selectedDepartment.value
          ]
        );
      } else if (selectedLeadDownload.value === "new") {
        setSaleleadDownloadData(
          saleLeadRawData?.gain_lead?.[selectedBranch.value]?.[
            selectedDepartment.value
          ]
        );
      } else if (selectedLeadDownload.value === "active") {
        setSaleleadDownloadData(
          saleLeadRawData.top_lead[selectedBranch.value][
            selectedDepartment.value
          ]
        );
      }
    }

    if (prospectleadDetailRawData) {
      const activeFilter = GetObject(
        GetArray(prospectleadDetailRawData.ss_email_dic).filter(
          (item: any) =>
            item.EMAIL_TYPE === prospectleadDetailRawData?.campaign?.[0]
        )
      );

      const inactiveFilter = GetObject(
        GetArray(prospectleadDetailRawData.ss_email_dic).filter(
          (item: any) =>
            item.EMAIL_TYPE === prospectleadDetailRawData?.campaign?.[1]
        )
      );

      setSalesMarketingProsperLeadEmailFormFillInfo({
        visitor: prospectleadDetailRawData?.form_fill_dic?.UNIDENTIFY?.slice(-1)
          ? WithCommas(
              prospectleadDetailRawData?.form_fill_dic?.UNIDENTIFY?.slice(-1)
            )
          : "",
        monthYear: prospectleadDetailRawData?.form_fill_dic?.END_PERIOD?.slice(
          -1
        )
          ? prospectleadDetailRawData?.form_fill_dic?.END_PERIOD?.slice(-1)
          : "",
        activeRecipient: activeFilter?.RECIPIENT?.slice(-1)
          ? WithCommas(activeFilter?.RECIPIENT?.slice(-1))
          : "",
        activeOpenRate: activeFilter?.OPEN_RATE?.slice(-1)
          ? Number(activeFilter?.OPEN_RATE?.slice(-1)).toFixed(1)
          : "",
        activeClickRate: activeFilter?.CLICK_RATE?.slice(-1)
          ? Number(activeFilter?.CLICK_RATE?.slice(-1)).toFixed(1)
          : "",
        inactiveRecipient: inactiveFilter?.RECIPIENT?.slice(-1)
          ? WithCommas(
              prospectleadDetailRawData?.ss_email_dic?.RECIPIENT?.slice(-1)
            )
          : "",
        inactiveOpenRate: inactiveFilter?.OPEN_RATE?.slice(-1)
          ? Number(inactiveFilter?.OPEN_RATE?.slice(-1)).toFixed(1)
          : "",
        inactiveClickRate: inactiveFilter?.CLICK_RATE?.slice(-1)
          ? Number(inactiveFilter?.CLICK_RATE?.slice(-1)).toFixed(1)
          : "",
      });
    }

    if (prRawData) {
      const prFilter = GetObject(
        GetArray(prRawData).filter(
          (item: any) =>
            item.BRANCH === selectedBranch.value &&
            item.DEPARTMENT === selectedDepartment.value
        )
      );

      setsalesMarketingTransactionsCountChartData(
        prFilter?.transaction ? prFilter?.transaction : []
      );
      setsalesMarketingTransactionsCountChartLabel(
        prFilter?.product_cons ? prFilter?.product_cons : []
      );
    }

    if (ruleRawData) {
      setSalesMarketingCrossSellProductdata(
        ruleRawData?.data ? ruleRawData?.data : []
      );
    }

    if (revinvData) {
      const revInvDataFilter = GetObject(
        GetArray(revinvData).filter((item: any) => {
          return (
            item.BRANCH === selectedBranch.value &&
            item.PRODUCT_TYPE_ALL === selectedDepartment.value
          );
        })
      );
      if (Object.keys(revInvDataFilter).length !== 0) {
        if (revInvDataFilter?.ACCOUNT_GROWTH) {
          const lastIndex = revInvDataFilter?.ACCOUNT_GROWTH?.length
            ? revInvDataFilter?.ACCOUNT_GROWTH?.length - 1
            : 0;

          if (revInvDataFilter?.TOTAL_ACCOUNT)
            setSalesmarketingActiveAccount(
              WithCommas(
                revInvDataFilter?.TOTAL_ACCOUNT?.[lastIndex]
                  ? revInvDataFilter?.TOTAL_ACCOUNT?.[lastIndex]
                  : ""
              )
            );

          if (revInvDataFilter?.AVG_TRANSACTION)
            setSalesmarketingTransactionInvoiceActive(
              WithCommas(
                revInvDataFilter?.AVG_TRANSACTION?.[lastIndex]
                  ? revInvDataFilter?.AVG_TRANSACTION?.[lastIndex]
                  : ""
              )
            );

          if (revInvDataFilter?.AVG_REVENUE)
            setSalesmarketingRevenueActiveAccount(
              WithCommas(
                revInvDataFilter?.AVG_REVENUE?.[lastIndex]
                  ? revInvDataFilter?.AVG_REVENUE?.[lastIndex]
                  : ""
              )
            );
        }
      } else {
        setSalesmarketingActiveAccount("-");
        setSalesmarketingTransactionInvoiceActive("-");
        setSalesmarketingRevenueActiveAccount("-");
      }
    }

    if (rankByRetentionData) {
      const retentionFilter = GetObject(
        GetArray(rankByRetentionData).filter(
          (item: any) => item.BRANCH === selectedBranch.value
        )
      );

      if (Object.keys(retentionFilter).length !== 0) {
        setsalesMarketingRetentionChartLabel(retentionFilter.SALESMAN);
        // setsalesMarketingRetentionChartLabel(retentionFilter.LABEL);
        setsalesMarketingRetentionChartData(retentionFilter.RETENTION);
      } else {
        setsalesMarketingRetentionChartData([]);
        setsalesMarketingRetentionChartLabel([]);
      }
    }

    if (branchRankByStableData) {
      // const branchRankByStableFilter = GetObject(
      //   GetArray(branchRankByStableData).filter(
      //     (item: any) => item.BRANCH === selectedBranch.value
      //   )
      // );

      // if (Object.keys(branchRankByStableFilter).length !== 0) {
      setsalesMarketingBranchRankByStableData(
        branchRankByStableData.STABLE_PERCENT
      );
      setsalesMarketingBranchRankByStableLabel(branchRankByStableData.BRANCH);
      // } else {
      //   setsalesMarketingBranchRankByStableData([]);
      //   setsalesMarketingBranchRankByStableLabel([]);
      // }
    }

    if (branchRankByEmailData) {
      // const branchRankByEmailFilter = GetObject(
      //   GetArray(branchRankByEmailData).filter(
      //     (item: any) => item.BRANCH === selectedBranch.value
      //   )
      // );

      // if (Object.keys(branchRankByEmailFilter).length !== 0) {
      setsalesMarketingBranchRankByEmailData(
        branchRankByEmailData.EMAIL_PERCENT
      );
      setsalesMarketingBranchRankByEmailLabel(branchRankByEmailData.BRANCH);
      // } else {
      //   setsalesMarketingBranchRankByEmailData([]);
      //   setsalesMarketingBranchRankByEmailLabel([]);
      // }
    }

    if (branchRankByRetentionData) {
      // const branchRankByRetentionFilter = GetObject(
      //   GetArray(branchRankByRetentionData).filter(
      //     (item: any) => item.BRANCH === selectedBranch.value
      //   )
      // );

      // if (Object.keys(branchRankByRetentionFilter).length !== 0) {
      setsalesMarketingBranchRankByRetentionData(
        branchRankByRetentionData.RETENTION
      );
      setsalesMarketingBranchRankByRetentionLabel(
        branchRankByRetentionData.BRANCH
      );
      // } else {
      //   setsalesMarketingBranchRankByRetentionData([]);
      //   setsalesMarketingBranchRankByRetentionLabel([]);
      // }
    }
  };

  const handleLeadDownload = () => {
    requestSaleLeadIfNeeded();
    if (saleleadDownloadData && saleleadDownloadData.length > 0)
      exportToExcelOther(saleleadDownloadData, selectedLeadDownload.label);
  };

  useEffect(() => {
    salesMarketingFilterData();
  }, [
    selectedBranch,
    selectedDepartment,
    verifiedSunRawData,
    formFillSumRawData,
    gainLost6RawData,
    gainLost12RawData,
    gainLost36RawData,
    JSON.stringify(revinvData),
    marketCustRawData,
    prcustRawData,
    prrevRawData,
    salstbRawData,
    salemRawData,
    leadRawData,
    lostRawData,
    gainRawData,
    selectedPeriod,
    selectedLeadDownload,
    prRawData,
    ruleRawData,
    cassRawData,
    rankByRetentionData,
    branchRankByStableData,
    branchRankByEmailData,
    branchRankByRetentionData,
    // The download data arrives on demand now, so its arrival must re-derive.
    saleLeadRawData,
  ]);

  const downloadCrossSellProduct = () => {
    if (salesMarketingCrossSellProductdata?.length === 0) {
      alert("There is no cross sell data available at this moment");
      return;
    }
    const crossSellDownloadData = salesMarketingCrossSellProductdata.map(
      ({
        CLIENT_ID,
        index,
        ...rest
      }: {
        CLIENT_ID: any;
        index: any;
        rest: any;
      }) => rest
    );

    exportToExcelOther(
      crossSellDownloadData,
      "Cross-Sell Potential by Product"
    );
  };

  const handleProgramDowload = () => {
    let tempDownloadData: any[] = [];
    let title: string = "";
    if (selectedProgram?.value === "email") {
      prospectleadDetailRawData?.ss_email_dic?.END_PERIOD.forEach(
        (element: any, index: any) => {
          tempDownloadData.push({
            PERIOD: element,
            CLICK_RATE:
              prospectleadDetailRawData?.ss_email_dic?.CLICK_RATE?.[index],
            EMAIL_TYPE:
              prospectleadDetailRawData?.ss_email_dic?.EMAIL_TYPE?.[index],
            OPEN_RATE:
              prospectleadDetailRawData?.ss_email_dic?.OPEN_RATE?.[index],
            RECIPIENT:
              prospectleadDetailRawData?.ss_email_dic?.RECIPIENT?.[index],
          });
        }
      );
      title = "Email Program";
    } else {
      prospectleadDetailRawData?.verified_all_dic?.month_year?.forEach(
        (element: any, index: any) => {
          tempDownloadData.push({
            month_year: element,
            verified_account:
              prospectleadDetailRawData?.verified_all_dic?.verified_account?.[
                index
              ],
            verified_contact:
              prospectleadDetailRawData?.verified_all_dic?.verified_contact?.[
                index
              ],
            verified_email:
              prospectleadDetailRawData?.verified_all_dic?.verified_email?.[
                index
              ],
          });
        }
      );
      title = "Verified Calling Program";
    }

    exportToExcelOther(tempDownloadData, title);
  };

  return (
    <Grid container sx={{}}>
      <Grid
        container
        sx={{
          padding: "0px 10px 10px 10px",
        }}
      >
        <Grid container item xs={12} sx={{ padding: "10px" }}>
          <Grid container item xs={5} sx={{ padding: "10px" }}>
            <SectionCard title="Prospect Leads, Programs and Tools Reports">
              {prospectLeadsReportsLoading ? (
                <Grid
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "300px",
                          flexBasis: "300px",
                    border: tokens.cardChrome.bodyBorder,
                    width: "100%",
                  }}
                >
                  <MiniSpinner />
                </Grid>
              ) : (
                <Grid
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    padding: "10px 20px 10px 20px",
                    border: tokens.cardChrome.bodyBorder,
                    backgroundColor: tokens.cardChrome.bodyBg,
                    gap: 2,
                    height: "100%",
                  }}
                >
                  <Grid
                    container
                    item
                    xs={12}
                    sx={{ padding: "0px 5% 0px 5%", gap: 2 }}
                  >
                    <Grid
                      item
                      xs={6}
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <FormControl fullWidth>
                        <Autocomplete
                          id="program"
                          value={selectedProgram}
                          onChange={(
                            _: SyntheticEvent,
                            newValue: string | null
                          ) => handleProgramChange(newValue)}
                          options={programOption}
                          isOptionEqualToValue={(option, newValue) => {
                            return option.value === newValue.value;
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Program"
                              placeholder="Program"
                            />
                          )}
                        />
                      </FormControl>
                    </Grid>
                    <Grid
                      sx={{
                        backgroundColor: tokens.cardChrome.controlGroupBg,
                        display: "flex",
                        borderRadius: "10px",
                      }}
                    >
                      <Button
                        onClick={() => handleProgramDowload()}
                        variant="outlined"
                        sx={{
                          color: tokens.cardChrome.controlText,
                          // padding: "0px 10px 0px 10px",
                        }}
                      >
                        Download Program
                      </Button>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    item
                    xs={12}
                    sx={{ padding: "0px 5% 0px 5%" }}
                  >
                    {selectedProgram.value === "calling" && (
                      <Grid container item xs={12} sx={{}}>
                        <Grid
                          container
                          item
                          xs={4}
                          sx={{
                            padding: "10px",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <Paper
                            elevation={2}
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              borderRadius: "10px",
                              padding: "10px",
                              gap: 3,
                              alignItems: "center",
                            }}
                          >
                            <Grid
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontWeight: "bold",
                                  color: tokens.tile.eyebrow,
                                }}
                              >
                                VERIFIED ACCOUNTS
                              </Typography>
                            </Grid>
                            <Grid
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px",
                                  color: tokens.tile.caption,
                                }}
                              >
                                Total
                              </Typography>
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: "bold",
                                  color: tokens.chart.series.transaction,
                                }}
                              >
                                {
                                  salesMarketingProsperLeadVerifiedInfo.accountTotal
                                }
                              </Typography>
                            </Grid>
                            <Grid
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px",
                                  color: tokens.tile.caption,
                                }}
                              >
                                {
                                  salesMarketingProsperLeadVerifiedInfo.monthYear
                                }
                              </Typography>
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: "bold",
                                  color: tokens.chart.series.activeAccount,
                                }}
                              >
                                {salesMarketingProsperLeadVerifiedInfo.accountM}
                              </Typography>
                            </Grid>
                            <Grid
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px",
                                  color: tokens.tile.caption,
                                }}
                              >
                                6 Month
                              </Typography>
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: "bold",
                                  color: tokens.chart.series.activeAccount,
                                }}
                              >
                                {
                                  salesMarketingProsperLeadVerifiedInfo.account6M
                                }
                              </Typography>
                            </Grid>
                            <Grid
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px",
                                  color: tokens.tile.caption,
                                }}
                              >
                                12 Month
                              </Typography>
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: "bold",
                                  color: tokens.chart.series.activeAccount,
                                }}
                              >
                                {
                                  salesMarketingProsperLeadVerifiedInfo.account12M
                                }
                              </Typography>
                            </Grid>
                          </Paper>
                        </Grid>
                        <Grid
                          container
                          item
                          xs={4}
                          sx={{
                            padding: "10px",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <Paper
                            elevation={2}
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              borderRadius: "10px",
                              padding: "10px",
                              gap: 3,
                              alignItems: "center",
                            }}
                          >
                            <Grid
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontWeight: "bold",
                                  color: tokens.tile.eyebrow,
                                }}
                              >
                                VERIFIED CONTACTS
                              </Typography>
                            </Grid>
                            <Grid
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px",
                                  color: tokens.tile.caption,
                                }}
                              >
                                Total
                              </Typography>
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: "bold",
                                  color: tokens.chart.series.transaction,
                                }}
                              >
                                {
                                  salesMarketingProsperLeadVerifiedInfo.countactTotal
                                }
                              </Typography>
                            </Grid>
                            <Grid
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px",
                                  color: tokens.tile.caption,
                                }}
                              >
                                {
                                  salesMarketingProsperLeadVerifiedInfo.monthYear
                                }
                              </Typography>
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: "bold",
                                  color: tokens.chart.series.activeAccount,
                                }}
                              >
                                {
                                  salesMarketingProsperLeadVerifiedInfo.constactM
                                }
                              </Typography>
                            </Grid>
                            <Grid
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px",
                                  color: tokens.tile.caption,
                                }}
                              >
                                6 Month
                              </Typography>
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: "bold",
                                  color: tokens.chart.series.activeAccount,
                                }}
                              >
                                {
                                  salesMarketingProsperLeadVerifiedInfo.constact6M
                                }
                              </Typography>
                            </Grid>
                            <Grid
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px",
                                  color: tokens.tile.caption,
                                }}
                              >
                                12 Month
                              </Typography>
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: "bold",
                                  color: tokens.chart.series.activeAccount,
                                }}
                              >
                                {
                                  salesMarketingProsperLeadVerifiedInfo.constact12M
                                }
                              </Typography>
                            </Grid>
                          </Paper>
                        </Grid>
                        <Grid
                          container
                          item
                          xs={4}
                          sx={{
                            padding: "10px",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <Paper
                            elevation={2}
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              borderRadius: "10px",
                              padding: "10px",
                              gap: 3,
                              alignItems: "center",
                            }}
                          >
                            <Grid
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontWeight: "bold",
                                  color: tokens.tile.eyebrow,
                                }}
                              >
                                VERIFIED EMAILS
                              </Typography>
                            </Grid>
                            <Grid
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px",
                                  color: tokens.tile.caption,
                                }}
                              >
                                Total
                              </Typography>
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: "bold",
                                  color: tokens.chart.series.transaction,
                                }}
                              >
                                {
                                  salesMarketingProsperLeadVerifiedInfo.emailTotal
                                }
                              </Typography>
                            </Grid>
                            <Grid
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px",
                                  color: tokens.tile.caption,
                                }}
                              >
                                {
                                  salesMarketingProsperLeadVerifiedInfo.monthYear
                                }
                              </Typography>
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: "bold",
                                  color: tokens.chart.series.activeAccount,
                                }}
                              >
                                {salesMarketingProsperLeadVerifiedInfo.emailM}
                              </Typography>
                            </Grid>
                            <Grid
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px",
                                  color: tokens.tile.caption,
                                }}
                              >
                                6 Month
                              </Typography>
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: "bold",
                                  color: tokens.chart.series.activeAccount,
                                }}
                              >
                                {salesMarketingProsperLeadVerifiedInfo.email6M}
                              </Typography>
                            </Grid>
                            <Grid
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px",
                                  color: tokens.tile.caption,
                                }}
                              >
                                12 Month
                              </Typography>
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: "bold",
                                  color: tokens.chart.series.activeAccount,
                                }}
                              >
                                {salesMarketingProsperLeadVerifiedInfo.email12M}
                              </Typography>
                            </Grid>
                          </Paper>
                        </Grid>
                      </Grid>
                    )}
                    {selectedProgram.value === "email" && (
                      <Grid container item xs={12} sx={{}}>
                        <Grid
                          container
                          item
                          xs={4}
                          sx={{
                            padding: "10px",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <Paper
                            elevation={2}
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              borderRadius: "10px",
                              padding: "10px",
                              gap: 3,
                              alignItems: "center",
                            }}
                          >
                            <Grid
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontWeight: "bold",
                                  color: tokens.tile.eyebrow,
                                }}
                              >
                                ACTIVE EMAILS
                              </Typography>
                            </Grid>
                            <Grid
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px",
                                  color: tokens.tile.caption,
                                }}
                              >
                                Recipients
                              </Typography>
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: "bold",
                                  color: tokens.chart.series.transaction,
                                }}
                              >
                                {
                                  salesMarketingProsperLeadEmailFormFillInfo.activeRecipient
                                }
                              </Typography>
                            </Grid>
                            <Grid
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px",
                                  color: tokens.tile.caption,
                                }}
                              >
                                Open Rate
                              </Typography>
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: "bold",
                                  color: tokens.chart.series.activeAccount,
                                }}
                              >
                                {
                                  salesMarketingProsperLeadEmailFormFillInfo.activeOpenRate
                                }{" "}
                                %
                              </Typography>
                            </Grid>
                            <Grid
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px",
                                  color: tokens.tile.caption,
                                }}
                              >
                                Click Rate
                              </Typography>
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: "bold",
                                  color: tokens.chart.series.activeAccount,
                                }}
                              >
                                {
                                  salesMarketingProsperLeadEmailFormFillInfo.activeClickRate
                                }{" "}
                                %
                              </Typography>
                            </Grid>
                          </Paper>
                        </Grid>
                        <Grid
                          container
                          item
                          xs={4}
                          sx={{
                            padding: "10px",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <Paper
                            elevation={2}
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              borderRadius: "10px",
                              padding: "10px",
                              gap: 3,
                              alignItems: "center",
                            }}
                          >
                            <Grid
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontWeight: "bold",
                                  color: tokens.tile.eyebrow,
                                }}
                              >
                                INACTIVE EMAILS
                              </Typography>
                            </Grid>
                            <Grid
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px",
                                  color: tokens.tile.caption,
                                }}
                              >
                                Recipients
                              </Typography>
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: "bold",
                                  color: tokens.chart.series.transaction,
                                }}
                              >
                                {
                                  salesMarketingProsperLeadEmailFormFillInfo.inactiveRecipient
                                }
                              </Typography>
                            </Grid>
                            <Grid
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px",
                                  color: tokens.tile.caption,
                                }}
                              >
                                Open Rate
                              </Typography>
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: "bold",
                                  color: tokens.chart.series.activeAccount,
                                }}
                              >
                                {
                                  salesMarketingProsperLeadEmailFormFillInfo.inactiveOpenRate
                                }
                                %
                              </Typography>
                            </Grid>
                            <Grid
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px",
                                  color: tokens.tile.caption,
                                }}
                              >
                                Click Rate
                              </Typography>
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: "bold",
                                  color: tokens.chart.series.activeAccount,
                                }}
                              >
                                {
                                  salesMarketingProsperLeadEmailFormFillInfo.inactiveClickRate
                                }{" "}
                                %
                              </Typography>
                            </Grid>
                          </Paper>
                        </Grid>
                        <Grid
                          container
                          item
                          xs={4}
                          sx={{
                            padding: "10px",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <Paper
                            elevation={2}
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              borderRadius: "10px",
                              padding: "10px",
                              gap: 3,
                              alignItems: "center",
                            }}
                          >
                            <Grid
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontWeight: "bold",
                                  color: tokens.tile.eyebrow,
                                }}
                              >
                                FORM FILLS
                              </Typography>
                            </Grid>
                            <Grid
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px",
                                  color: tokens.tile.caption,
                                }}
                              >
                                Visitors
                              </Typography>
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: "bold",
                                  color: tokens.chart.series.transaction,
                                }}
                              >
                                {
                                  salesMarketingProsperLeadEmailFormFillInfo.visitor
                                }
                              </Typography>
                            </Grid>
                            <Grid
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px",
                                  color: tokens.tile.caption,
                                }}
                              >
                                {
                                  salesMarketingProsperLeadEmailFormFillInfo.monthYear
                                }
                              </Typography>
                            </Grid>
                          </Paper>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              )}
            </SectionCard>
          </Grid>
          <Grid container item xs={7} sx={{ padding: "10px" }}>
            <SectionCard title="Last Purchase Customer Retention Leads">
              <Grid
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "10px 20px 10px 20px",
                  border: tokens.cardChrome.bodyBorder,
                  backgroundColor: tokens.cardChrome.bodyBg,
                  gap: 2,
                  height: "100%",
                }}
              >
                {lastPurchaseCustomerLeadsLoading ? (
                  <Grid
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "300px",
                          flexBasis: "300px",
                      border: tokens.cardChrome.bodyBorder,
                      width: "100%",
                    }}
                  >
                    <MiniSpinner />
                  </Grid>
                ) : (
                  <Grid container item xs={12}>
                    <Grid
                      container
                      item
                      xs={12}
                      sx={{
                        display: "flex",
                        justifyContent: "right",
                        gap: 2,
                        height: "50px",
                      }}
                    >
                      <Grid container item xs={6}>
                        <FormControl fullWidth>
                          <Autocomplete
                            id="program"
                            value={selectedLeadDownload}
                            onChange={(
                              _: SyntheticEvent,
                              newValue: string | null
                            ) => handleLeadDownloadChange(newValue)}
                            options={leadDownloadOption}
                            isOptionEqualToValue={(option, newValue) => {
                              return option.value === newValue.value;
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Customers"
                                placeholder="Customers"
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>
                      <Grid
                        sx={{
                          backgroundColor: tokens.cardChrome.controlGroupBg,
                          display: "flex",
                          borderRadius: "10px",
                        }}
                      >
                        <Button
                          onClick={() => handleLeadDownload()}
                          variant="outlined"
                          sx={{
                            color: tokens.cardChrome.controlText,
                            // padding: "0px 10px 0px 10px",
                          }}
                        >
                          Download Leads
                        </Button>
                      </Grid>
                    </Grid>
                    <Grid container item xs={12}>
                      <Typography sx={{ fontWeight: "bold" }}>
                        <span style={{ fontSize: "20px" }}>
                          Lead Customers:
                        </span>{" "}
                        Who have not Purchased in 9 to 12 Weeks
                      </Typography>
                    </Grid>
                    <Grid container item xs={12}>
                      <Grid
                        container
                        item
                        xs={4}
                        sx={{ justifyContent: "center" }}
                      >
                        <Typography sx={{}}>
                          # of Customer :{" "}
                          <span
                            style={{ fontWeight: "bold", fontSize: "20px" }}
                          >
                            {salesMarketingLeadsCustomers.cust_lead}
                          </span>
                        </Typography>
                      </Grid>
                      <Grid
                        container
                        item
                        xs={4}
                        sx={{ justifyContent: "center" }}
                      >
                        <Typography sx={{}}>
                          Avg Last Purchase : ${" "}
                          <span
                            style={{ fontWeight: "bold", fontSize: "20px" }}
                          >
                            {salesMarketingLeadsCustomers.lead_purchase}
                          </span>
                        </Typography>
                      </Grid>
                      <Grid
                        container
                        item
                        xs={4}
                        sx={{ justifyContent: "center" }}
                      >
                        <Typography sx={{}}>
                          Avg Revenue 12mm : ${" "}
                          <span
                            style={{ fontWeight: "bold", fontSize: "20px" }}
                          >
                            {salesMarketingLeadsCustomers.lead_rev}
                          </span>
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container item xs={12}>
                      <Typography sx={{ fontWeight: "bold" }}>
                        <span style={{ fontSize: "20px" }}>
                          Lost Customers:
                        </span>{" "}
                        Who have not Purchased in the past 12 months
                      </Typography>
                    </Grid>
                    <Grid container item xs={12}>
                      <Grid
                        container
                        item
                        xs={4}
                        sx={{ justifyContent: "center" }}
                      >
                        <Typography sx={{}}>
                          # of Customer :{" "}
                          <span
                            style={{ fontWeight: "bold", fontSize: "20px" }}
                          >
                            {salesMarketingLostCustomers.cust_lost}
                          </span>
                        </Typography>
                      </Grid>
                      <Grid
                        container
                        item
                        xs={4}
                        sx={{ justifyContent: "center" }}
                      >
                        <Typography sx={{}}>
                          Avg Last Purchase : ${" "}
                          <span
                            style={{ fontWeight: "bold", fontSize: "20px" }}
                          >
                            {salesMarketingLostCustomers.lost_purchase}
                          </span>
                        </Typography>
                      </Grid>
                      <Grid
                        container
                        item
                        xs={4}
                        sx={{ justifyContent: "center" }}
                      >
                        <Typography sx={{}}>
                          Avg Revenue 12mm : ${" "}
                          <span
                            style={{ fontWeight: "bold", fontSize: "20px" }}
                          >
                            {salesMarketingLostCustomers.lost_rev}
                          </span>
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container item xs={12}>
                      <Typography sx={{ fontWeight: "bold" }}>
                        <span style={{ fontSize: "20px" }}>
                          Gained Customers:
                        </span>{" "}
                        Who have Purchased in the past month but not in the
                        prior 12 months
                      </Typography>
                    </Grid>
                    <Grid container item xs={12}>
                      <Grid
                        container
                        item
                        xs={4}
                        sx={{ justifyContent: "center" }}
                      >
                        <Typography sx={{}}>
                          # of Customer :{" "}
                          <span
                            style={{ fontWeight: "bold", fontSize: "20px" }}
                          >
                            {salesMarketingGainedCustomers.cust_gain}
                          </span>
                        </Typography>
                      </Grid>
                      <Grid
                        container
                        item
                        xs={4}
                        sx={{ justifyContent: "center" }}
                      >
                        <Typography sx={{}}>
                          Avg Last Purchase : ${" "}
                          <span
                            style={{ fontWeight: "bold", fontSize: "20px" }}
                          >
                            {salesMarketingGainedCustomers.gain_purchase}
                          </span>
                        </Typography>
                      </Grid>
                      <Grid
                        container
                        item
                        xs={4}
                        sx={{ justifyContent: "center" }}
                      >
                        <Typography sx={{}}>
                          Avg Revenue 12mm : ${" "}
                          <span
                            style={{ fontWeight: "bold", fontSize: "20px" }}
                          >
                            {salesMarketingGainedCustomers.gain_rev}
                          </span>
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container item xs={12}>
                      <Typography sx={{ fontWeight: "bold" }}>
                        <span style={{ fontSize: "20px" }}>
                          Active Customers:
                        </span>{" "}
                        Who have Purchased in the past 12 months
                      </Typography>
                    </Grid>
                    <Grid container item xs={12}>
                      <Grid
                        container
                        item
                        xs={4}
                        sx={{ justifyContent: "center" }}
                      >
                        <Typography sx={{}}>
                          # of Customer :{" "}
                          <span
                            style={{ fontWeight: "bold", fontSize: "20px" }}
                          >
                            {salesmarketingActiveAccount}
                          </span>
                        </Typography>
                      </Grid>
                      <Grid
                        container
                        item
                        xs={4}
                        sx={{ justifyContent: "center" }}
                      >
                        <Typography sx={{}}>
                          Avg Last Purchase : ${" "}
                          <span
                            style={{ fontWeight: "bold", fontSize: "20px" }}
                          >
                            {salesmarketingTransactionInvoiceActive}
                          </span>
                        </Typography>
                      </Grid>
                      <Grid
                        container
                        item
                        xs={4}
                        sx={{ justifyContent: "center" }}
                      >
                        <Typography sx={{}}>
                          Avg Revenue 12mm : ${" "}
                          <span
                            style={{ fontWeight: "bold", fontSize: "20px" }}
                          >
                            {salesmarketingRevenueActiveAccount}
                          </span>
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </SectionCard>
          </Grid>
        </Grid>
        <Grid container item xs={12} sx={{ padding: "20px" }}>
          <SectionCard title="ROI for Sales & Marketing Programs">
            {marketByCustomerLoading ? (
              <Grid
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "300px",
                          flexBasis: "300px",
                  border: tokens.cardChrome.bodyBorder,
                  width: "100%",
                }}
              >
                <MiniSpinner />
              </Grid>
            ) : (
              <Grid
                container
                item
                xs={12}
                sx={{
                  padding: "10px 20px 10px 20px",
                  border: tokens.cardChrome.bodyBorder,
                  backgroundColor: tokens.cardChrome.bodyBg,
                  gap: 2,
                }}
              >
                <Grid
                  container
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Grid
                    item
                    xs={2}
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <FormControl fullWidth>
                      <Autocomplete
                        id="sales_rep"
                        value={selectedPeriod}
                        onChange={(
                          _: SyntheticEvent,
                          newValue: string | null
                        ) => handlePeriodChange(newValue)}
                        options={periodOption}
                        isOptionEqualToValue={(option, newValue) => {
                          return option.id === newValue.id;
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Period"
                            placeholder="Period"
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid container item xs={12} sx={{ display: "flex" }}>
                  <TableContainer component={Paper} sx={{}}>
                    <Table size="small" aria-label="simple table">
                      <TableHead>
                        <TableRow
                          sx={{
                            borderBottom: "none",
                            backgroundColor: tokens.color.primary,
                            color: tokens.cardChrome.headerText,
                          }}
                        >
                          <TableCell
                            sx={{
                              borderBottom: "none",
                              color: tokens.cardChrome.headerText,
                            }}
                          >
                            Program
                          </TableCell>
                          <TableCell
                            sx={{
                              borderBottom: "none",
                              fontWeight: "bold",
                              color: tokens.cardChrome.headerText,
                            }}
                            align="center"
                          >
                            Transaction Per Customer
                          </TableCell>
                          <TableCell
                            sx={{
                              borderBottom: "none",
                              fontWeight: "bold",
                              color: tokens.cardChrome.headerText,
                            }}
                            align="center"
                          >
                            Revenue Per Customer
                          </TableCell>
                          <TableCell
                            sx={{
                              borderBottom: "none",
                              fontWeight: "bold",
                              color: tokens.cardChrome.headerText,
                            }}
                            align="center"
                          >
                            Change From Not Program
                          </TableCell>
                          <TableCell
                            sx={{
                              borderBottom: "none",
                              fontWeight: "bold",
                              color: tokens.cardChrome.headerText,
                            }}
                            align="center"
                          >
                            Cost per Customer
                          </TableCell>
                          <TableCell
                            sx={{
                              borderBottom: "none",
                              fontWeight: "bold",
                              color: tokens.cardChrome.headerText,
                            }}
                            align="center"
                          >
                            ROI times Active Customer
                          </TableCell>
                          <TableCell
                            sx={{
                              borderBottom: "none",
                              fontWeight: "bold",
                              color: tokens.cardChrome.headerText,
                            }}
                            align="center"
                          >
                            Customer Count
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {salesMarketingMarketCustTable.map((row: any) => (
                          <TableRow
                            key={row["Programs"]}
                            sx={{
                              borderBottom: "none",
                            }}
                          >
                            <TableCell
                              component="th"
                              scope="row"
                              sx={{
                                borderBottom: "none",
                                fontWeight: "bold",
                              }}
                            >
                              {row["Programs"]}
                            </TableCell>
                            <TableCell
                              sx={{
                                borderBottom: "none",
                              }}
                              align="center"
                            >
                              {row["Transaction per Customer"]}
                            </TableCell>
                            <TableCell
                              sx={{
                                borderBottom: "none",
                              }}
                              align="center"
                            >
                              {row["Revenue per customer"]}
                            </TableCell>
                            <TableCell
                              sx={{
                                borderBottom: "none",
                                fontWeight: "bold",
                              }}
                              align="center"
                            >
                              {row["Change From Not Program"]}
                            </TableCell>
                            <TableCell
                              sx={{
                                borderBottom: "none",
                              }}
                              align="center"
                            >
                              {row["Cost per Customer"]}
                            </TableCell>
                            <TableCell
                              sx={{
                                borderBottom: "none",
                                fontWeight: "bold",
                              }}
                              align="center"
                            >
                              {row["ROI times Active Customers"]}
                            </TableCell>
                            <TableCell
                              sx={{
                                borderBottom: "none",
                              }}
                              align="center"
                            >
                              {row["Active Customer"]}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </Grid>
            )}
          </SectionCard>
        </Grid>
        <Grid container item xs={12} sx={{ padding: "10px" }}>
          <Grid container item xs={6} sx={{ padding: "10px" }}>
            <SectionCard title="Product Analysis">
              <Grid sx={{ border: tokens.cardChrome.bodyBorder }}>
                <Grid sx={{ padding: "10px 10px 0px 10px" }}>
                  <Grid sx={{ display: "flex" }}>
                    <SegmentedControl
                      options={[
                        { value: "TOP_20_PRODUCT", label: "Top 20 Product" },
                        {
                          value: "FREQUENTLY_PURCHASED",
                          label: "Frequently Purchased Together",
                        },
                      ]}
                      value={activeProductAnalysis}
                      onChange={handleProductAnalysisChange}
                    />
                  </Grid>
                </Grid>
                {activeProductAnalysis === "TOP_20_PRODUCT" && (
                  <Grid
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    {productByCustomerCountLoading ? (
                      // Not `item xs={12}`: the parent is a column FLEX box
                      // (not a Grid container), so xs-12's flex-basis:100%
                      // only hijacks the vertical axis and squashes the
                      // reserved height while loading.
                      <Grid
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "300px",
                          flexBasis: "300px",
                          width: "100%",
                        }}
                      >
                        <MiniSpinner />
                      </Grid>
                    ) : (
                      <Grid
                        container
                        item
                        xs={12}
                        sx={{
                          padding: "0px 20px 10px 20px",
                          backgroundColor: tokens.cardChrome.bodyBg,
                          gap: 2,
                        }}
                      >
                        <Grid
                          sx={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Grid sx={{}}>
                            <Grid
                              sx={{ justifyContent: "center", padding: "5px" }}
                            >
                              <Button
                                onClick={() => downloadCrossSellProduct()}
                                variant="outlined"
                                sx={{
                                  color: tokens.cardChrome.controlText,
                                  padding: "0px 20px 0px 20px",
                                  // textTransform: "capitalize",
                                }}
                              >
                                Download
                              </Button>
                            </Grid>
                          </Grid>
                          <Grid
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <Grid sx={{ display: "flex" }}>
                              <SegmentedControl
                                preserveLabelCase
                                options={[
                                  {
                                    value: "TRANSACTIONS_COUNT",
                                    label: "Transactions Count",
                                  },
                                  {
                                    value: "CUSTOMER_COUNT",
                                    label: "Customer Count",
                                  },
                                  { value: "REVENUE", label: "Revenue" },
                                ]}
                                value={activeCustomerCount}
                                onChange={handleCustomerCountNav}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid container item xs={12} sx={{ height: "300px" }}>
                          {activeCustomerCount === "TRANSACTIONS_COUNT" && (
                            <BarChart
                              series={[
                                {
                                  data: salesMarketingTransactionsCountChartData,
                                  label: "Average",
                                  color: tokens.chart.series.activeAccount,
                                  valueFormatter: (v) =>
                                    v === null ? "" : `${WithCommas(v)}`,
                                },
                              ]}
                              yAxis={[
                                {
                                  scaleType: "band",
                                  data: salesMarketingTransactionsCountChartLabel,
                                },
                              ]}
                              xAxis={[{}]}
                              slotProps={{
                                legend: {
                                  direction: "row",
                                  position: {
                                    vertical: "top",
                                    horizontal: "right",
                                  },
                                  padding: 0,
                                  itemMarkWidth: 15,
                                  itemMarkHeight: 15,
                                },
                              }}
                              margin={{
                                left: 100,
                                right: 20,
                                top: 40,
                                bottom: 40,
                              }}
                              layout="horizontal"
                              grid={{ vertical: true, horizontal: true }}
                            />
                          )}
                          {activeCustomerCount === "CUSTOMER_COUNT" && (
                            <BarChart
                              series={[
                                {
                                  data: salesMarketingProductCustomerChartdata,
                                  label: "Average",
                                  color: tokens.chart.series.activeAccount,
                                  valueFormatter: (v) =>
                                    v === null ? "" : `${WithCommas(v)}`,
                                },
                              ]}
                              yAxis={[
                                {
                                  scaleType: "band",
                                  data: salesMarketingProductCustomerChartLabel,
                                },
                              ]}
                              xAxis={[]}
                              slotProps={{
                                legend: {
                                  direction: "row",
                                  position: {
                                    vertical: "top",
                                    horizontal: "right",
                                  },
                                  padding: 0,
                                  itemMarkWidth: 15,
                                  itemMarkHeight: 15,
                                },
                              }}
                              margin={{
                                left: 100,
                                right: 20,
                                top: 40,
                                bottom: 40,
                              }}
                              layout="horizontal"
                              grid={{ vertical: true, horizontal: true }}
                            />
                          )}
                          {activeCustomerCount === "REVENUE" && (
                            <BarChart
                              series={[
                                {
                                  data: salesMarketingProductRevenueChartData,
                                  label: "Average",
                                  color: tokens.chart.series.activeAccount,
                                  valueFormatter: (v) =>
                                    v === null ? "" : `$ ${WithCommas(v)}`,
                                },
                              ]}
                              yAxis={[
                                {
                                  scaleType: "band",
                                  data: salesMarketingProductRevenueChartLabel,
                                },
                              ]}
                              xAxis={[
                                {
                                  id: "top_axis_id",
                                  scaleType: "linear",
                                  valueFormatter: (v) =>
                                    v === null ? "" : `$ ${v}`,
                                },
                              ]}
                              slotProps={{
                                legend: {
                                  direction: "row",
                                  position: {
                                    vertical: "top",
                                    horizontal: "right",
                                  },
                                  padding: 0,
                                  itemMarkWidth: 15,
                                  itemMarkHeight: 15,
                                },
                              }}
                              margin={{
                                left: 120,
                                right: 20,
                                top: 40,
                                bottom: 40,
                              }}
                              layout="horizontal"
                              grid={{ vertical: true, horizontal: true }}
                            />
                          )}
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                )}
                {activeProductAnalysis === "FREQUENTLY_PURCHASED" && (
                  <Grid
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    {getAssociatedProductLoading ? (
                      // Not `item xs={12}` — see the TOP_20 twin above.
                      <Grid
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "300px",
                          flexBasis: "300px",
                          // border: "1px solid grey",
                          width: "100%",
                        }}
                      >
                        <MiniSpinner />
                      </Grid>
                    ) : (
                      <Grid
                        container
                        item
                        xs={12}
                        sx={{
                          padding: "0px 20px 10px 20px",
                          // border: "1px solid grey",
                          backgroundColor: tokens.cardChrome.bodyBg,
                          gap: 2,
                        }}
                      >
                        <QueryClientProvider client={frequentlyPurchasedClient}>
                          <FrequentlyPurchased />
                        </QueryClientProvider>
                      </Grid>
                    )}
                  </Grid>
                )}
              </Grid>
            </SectionCard>
          </Grid>
          <Grid container item xs={6} sx={{ padding: "10px" }}>
            <SectionCard title={activeRank === "SALES_REP" ? "Sales Rep Ranking" : "Branches Ranking"}>
              {rankByStableAccountLoading ? (
                <Grid
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "300px",
                          flexBasis: "300px",
                    border: tokens.cardChrome.bodyBorder,
                    width: "100%",
                  }}
                >
                  <MiniSpinner />
                </Grid>
              ) : (
                <Grid
                  container
                  item
                  xs={12}
                  sx={{
                    padding: "10px 20px 10px 20px",
                    border: tokens.cardChrome.bodyBorder,
                    backgroundColor: tokens.cardChrome.bodyBg,
                    gap: 2,
                  }}
                >
                  <Grid sx={{}}>
                    <Grid sx={{ display: "flex" }}>
                      <SegmentedControl
                        options={[
                          { value: "BRANCH", label: "Branches" },
                          { value: "SALES_REP", label: "Sales Rep" },
                        ]}
                        value={activeRank}
                        onChange={handleRankChange}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    sx={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    {activeSMRevenueMonth === "STABLE_ACCOUNT" && (
                      <Grid
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          flexDirection: "row",
                          gap: 1,
                        }}
                      >
                        <Typography sx={{ fontWeight: "bold" }}>
                          STABLE ACCOUNT TARGET
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{
                            color: tokens.chart.series.revenueTeal,
                            fontWeight: "bold",
                          }}
                        >
                          &gt; 40%
                        </Typography>
                      </Grid>
                    )}
                    {activeSMRevenueMonth === "EMAIL" && (
                      <Grid
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          flexDirection: "column",
                        }}
                      >
                        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                          CUSTOMER EMAIL % TARGET
                        </Typography>
                        <Typography sx={{ color: tokens.chart.series.revenueTeal }}>
                          &gt;95%
                        </Typography>
                      </Grid>
                    )}
                    {activeSMRevenueMonth === "RETENTION" && (
                      <Grid
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          flexDirection: "column",
                        }}
                      >
                        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                          RETENTION RATE TARGET
                        </Typography>
                        <Typography sx={{ color: tokens.chart.series.revenueTeal }}>
                          &gt;96%
                        </Typography>
                      </Grid>
                    )}
                    <Grid sx={{}}>
                      <Grid sx={{ display: "flex" }}>
                        <SegmentedControl
                          options={[
                            { value: "RETENTION", label: "Retention %" },
                            { value: "STABLE_ACCOUNT", label: "STABLE ACCOUNT %" },
                            { value: "EMAIL", label: "EMAIL %" },
                          ]}
                          value={activeSMRevenueMonth}
                          onChange={handleSMRevenueMonthNav}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  {activeRank === "SALES_REP" ? (
                    <Grid container item xs={12} sx={{ height: "300px" }}>
                      {activeSMRevenueMonth === "STABLE_ACCOUNT" && (
                        <BarChart
                          series={[
                            {
                              data: salesMarketingStableAccountChartData,
                              label: "Sales Rep Stable Account",
                              color: tokens.chart.series.activeAccount,
                              valueFormatter: (v) =>
                                v === null ? "" : `${v} %`,
                            },
                          ]}
                          yAxis={[
                            {
                              scaleType: "band",
                              data: salesMarketingStableAccountChartLabel,
                            },
                          ]}
                          xAxis={[{ label: "Percentage %" }]}
                          slotProps={{
                            legend: {
                              direction: "row",
                              position: {
                                vertical: "top",
                                horizontal: "right",
                              },
                              padding: 0,
                              itemMarkWidth: 15,
                              itemMarkHeight: 15,
                            },
                          }}
                          margin={{
                            left: 150,
                            right: 20,
                            top: 40,
                            bottom: 40,
                          }}
                          layout="horizontal"
                          grid={{ vertical: true, horizontal: true }}
                        />
                      )}
                      {activeSMRevenueMonth === "EMAIL" && (
                        <BarChart
                          series={[
                            {
                              data: salesMarketingEmailChartData,
                              label: "Sales Rep Email",
                              color: tokens.chart.series.activeAccount,
                              valueFormatter: (v) =>
                                v === null ? "" : `${v} %`,
                            },
                          ]}
                          yAxis={[
                            {
                              scaleType: "band",
                              data: salesMarketingEmailChartLabel,
                            },
                          ]}
                          xAxis={[{ label: "Percentage %" }]}
                          slotProps={{
                            legend: {
                              direction: "row",
                              position: {
                                vertical: "top",
                                horizontal: "right",
                              },
                              padding: 0,
                              itemMarkWidth: 15,
                              itemMarkHeight: 15,
                            },
                          }}
                          margin={{
                            left: 150,
                            right: 20,
                            top: 40,
                            bottom: 40,
                          }}
                          layout="horizontal"
                          grid={{ vertical: true, horizontal: true }}
                        />
                      )}
                      {activeSMRevenueMonth === "RETENTION" && (
                        <BarChart
                          series={[
                            {
                              data: salesMarketingRetentionChartData,
                              label: "Sales Rep Retention",
                              color: tokens.chart.series.activeAccount,
                              valueFormatter: (v) =>
                                v === null ? "" : `${v} %`,
                            },
                          ]}
                          yAxis={[
                            {
                              scaleType: "band",
                              data: salesMarketingRetentionChartLabel,
                            },
                          ]}
                          xAxis={[{ label: "Percentage %" }]}
                          slotProps={{
                            legend: {
                              direction: "row",
                              position: {
                                vertical: "top",
                                horizontal: "right",
                              },
                              padding: 0,
                              itemMarkWidth: 15,
                              itemMarkHeight: 15,
                            },
                          }}
                          margin={{
                            left: 150,
                            right: 20,
                            top: 40,
                            bottom: 40,
                          }}
                          layout="horizontal"
                          grid={{ vertical: true, horizontal: true }}
                        />
                      )}
                    </Grid>
                  ) : (
                    <Grid container item xs={12} sx={{ height: "300px" }}>
                      {activeSMRevenueMonth === "STABLE_ACCOUNT" && (
                        <BarChart
                          series={[
                            {
                              data: salesMarketingBranchRankByStableData,
                              label: "Branch Stable Account",
                              color: tokens.chart.series.activeAccount,
                              valueFormatter: (v) =>
                                v === null ? "" : `${v} %`,
                            },
                          ]}
                          yAxis={[
                            {
                              scaleType: "band",
                              data: salesMarketingBranchRankByStableLabel,
                            },
                          ]}
                          xAxis={[{ label: "Percentage %" }]}
                          slotProps={{
                            legend: {
                              direction: "row",
                              position: {
                                vertical: "top",
                                horizontal: "right",
                              },
                              padding: 0,
                              itemMarkWidth: 15,
                              itemMarkHeight: 15,
                            },
                          }}
                          margin={{
                            left: 150,
                            right: 20,
                            top: 40,
                            bottom: 40,
                          }}
                          layout="horizontal"
                          grid={{ vertical: true, horizontal: true }}
                        />
                      )}
                      {activeSMRevenueMonth === "EMAIL" && (
                        <BarChart
                          series={[
                            {
                              data: salesMarketingBranchRankByEmailData,
                              label: "Branch Email",
                              color: tokens.chart.series.activeAccount,
                              valueFormatter: (v) =>
                                v === null ? "" : `${v} %`,
                            },
                          ]}
                          yAxis={[
                            {
                              scaleType: "band",
                              data: salesMarketingBranchRankByEmailLabel,
                            },
                          ]}
                          xAxis={[{ label: "Percentage %" }]}
                          slotProps={{
                            legend: {
                              direction: "row",
                              position: {
                                vertical: "top",
                                horizontal: "right",
                              },
                              padding: 0,
                              itemMarkWidth: 15,
                              itemMarkHeight: 15,
                            },
                          }}
                          margin={{
                            left: 150,
                            right: 20,
                            top: 40,
                            bottom: 40,
                          }}
                          layout="horizontal"
                          grid={{ vertical: true, horizontal: true }}
                        />
                      )}
                      {activeSMRevenueMonth === "RETENTION" && (
                        <BarChart
                          series={[
                            {
                              data: salesMarketingBranchRankByRetentionData,
                              label: "Branch Retention",
                              color: tokens.chart.series.activeAccount,
                              valueFormatter: (v) =>
                                v === null ? "" : `${v} %`,
                            },
                          ]}
                          yAxis={[
                            {
                              scaleType: "band",
                              data: salesMarketingBranchRankByRetentionLabel,
                            },
                          ]}
                          xAxis={[{ label: "Percentage %" }]}
                          slotProps={{
                            legend: {
                              direction: "row",
                              position: {
                                vertical: "top",
                                horizontal: "right",
                              },
                              padding: 0,
                              itemMarkWidth: 15,
                              itemMarkHeight: 15,
                            },
                          }}
                          margin={{
                            left: 150,
                            right: 20,
                            top: 40,
                            bottom: 40,
                          }}
                          layout="horizontal"
                          grid={{ vertical: true, horizontal: true }}
                        />
                      )}
                    </Grid>
                  )}
                </Grid>
              )}
            </SectionCard>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SalesMarketing;
